// extracted by mini-css-extract-plugin
export default {"data":"Content_data__4Rta5","actionButton":"Content_actionButton__kYHHS","placeHolderShimmer":"Content_placeHolderShimmer__alTPJ"};